import PropTypes from 'prop-types';

export const AddressProps = PropTypes.shape({
  id: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  address3: PropTypes.string,
  city: PropTypes.string,
  stateCode: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string
});

export const AddressDefaults = {
  id: null,
  address1: '',
  address2: '',
  address3: '',
  city: '',
  stateCode: '',
  postalCode: '',
  countryCode: ''
};
